<template>
  <FullScreenPopup
    ref="popup"
    :title="title"
    :lock-scroll="true"
  >
    <div class="submit-info-popup">
      {{ message }}

      <div class="submit-info-popup__controls">
        <OrangeFancyButton :method="close">Зрозуміло</OrangeFancyButton>
      </div>
    </div>
  </FullScreenPopup>
</template>

<script>
import { OrangeFancyButton } from '@/shared/ui/form';
import { FullScreenPopup } from '@/shared/ui/popup';

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
  },
  components: { OrangeFancyButton, FullScreenPopup },
  methods: {
    open() {
      this.$refs.popup.open();
    },
    close() {
      this.$refs.popup.close();
    },
  },
};
</script>

<style scoped lang="scss">
.submit-info-popup {
  &__controls {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
}
</style>
